module.exports = __webpack_public_path__ + "img/avatar5.9e389543.jpg";